<template>
  <section class="zoom-section" :style="{ backgroundImage: activityData.images.bg ? `url(${activityData.images.bg})` : 'none' }">
    <Header />
    <div class="zoom-container">
      <div class="zoom-activity-info" v-show="!showZoomIframe">
        <img :src="activityData.images.poster" v-if="activityData.images.poster" />
        <!-- <label v-html="activityData.description"></label> -->
      </div>
      <div class="zoom-activation-btns" v-show="!showZoomIframe">
        <button @click="join" class="join-btn">
          <i class="fas fa-video"></i>
          <label>ABRIR NO SITE</label>
        </button>
        <button @click="openLink" class="open-link-btn">
          <i class="fas fa-external-link-alt"></i>
          ABRIR NO APP
        </button>
      </div>

      <!-- <div class="iframe-close-btn" v-show="showZoomIframe" @click.prevent="closeIframe"><i class="fas fa-times-circle"></i></div> -->
      <div class="zoom-activity-info-mini" v-if="showZoomIframe">
        <span class="collapse-bar" @click="showMiniInfo = !showMiniInfo"><i class="fas fa-info"></i></span>
        <label v-html="activityData.activity" v-if="showMiniInfo"></label>
        <label v-html="activityData.description" v-if="showMiniInfo"></label>
        <div class="zoom-app-btn open-link-btn" @click="openLink" v-if="showMiniInfo">
          <i class="fas fa-external-link-alt" style="font-size: 1rem"></i>
          ABRIR NO APP
        </div>
      </div>
      <iframe id="zoomIframe" style="width: 100%; height: 100%" src="https://meet-zoom.blitzar.com.br/" allow="camera; microphone; fullscreen" frameborder="0" v-show="showZoomIframe"></iframe>
    </div>
    <Footer style="position: fixed; bottom: 0" v-show="!showZoomIframe" />
  </section>
</template>

<script>
import Header from '@/components/general/Header.vue';
import Footer from '@/components/general/Footer.vue';
import api from '@/services/api.js';
import Banner from '@/components/banners/Banner.vue';

export default {
  name: 'Conference',
  components: { Header, Banner, Footer },

  data() {
    return {
      profileConfig: null,
      activityData: { images: {}, property: {} },
      showZoomIframe: false,
      showMiniInfo: true,
    };
  },
  watch: {
    $route() {
      this.loadActivity();
    },
  },
  methods: {
    loadActivity() {
      api
        .get(`activity/${this.$route.params.stream}`)
        .then((response) => {
          this.activityData = { ...this.activityData, ...response.data };
          this.activityData.images = JSON.parse(response.data.images);
          this.activityData.property = JSON.parse(response.data.property);
        })

        .catch((err) => {
          console.error(err);
        });
    },
    join() {
      this.showZoomIframe = true;

      this.$nextTick((_) => {
        document.getElementById('zoomIframe').contentWindow.postMessage(
          {
            sender: 'conference',
            user: this.$store.state.user.name,
            language: 'pt-PT',
            msg: this.activityData.property.meetLink,
          },
          '*',
        );
        // console.log('postMessage', this.activityData.property.meetLink);
      });
    },
    openLink() {
      window.open(this.activityData.property.meetLink);
    },
    closeIframe() {
      this.showZoomIframe = false;
    },

    messageReceiver(e) {
      // console.log('messageReceiver', e.data);
      if (e.data.meetingReady != undefined) this.showZoomIframe = e.data.meetingReady;
    },
  },

  beforeMount() {
    this.profileConfig = this.$store.state.template.profileConfig;

    this.loadActivity();
  },
  mounted() {
    window.addEventListener('message', this.messageReceiver);
  },
  beforeDestroy() {
    document.getElementById('zoomIframe').contentWindow.postMessage(
      {
        sender: 'logout',
        user: this.$store.state.user.name,
        language: 'pt-PT',
        msg: 'logout',
      },
      '*',
    );
    // console.log('postMessage', 'logout');
  },
};
</script>

<style lang="scss">
.zoom-section {
  background-color: var(--main-color);
  background-position: center;
  background-size: cover;
  background-attachment: fixed;
  background-repeat: repeat-y;
  width: 100vw;
  min-height: 100dvh;
  // padding-bottom: 20px;

  display: flex;
  justify-content: center;
}
.zoom-container {
  position: relative;
  width: auto;
  flex-grow: 1;
  margin-top: 99px;
  height: 100dvh;
  overflow-y: auto;

  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  @include media('<=phone-plus') {
    margin-top: 50px;
    align-content: center;
  }
  .zoom-activity-info {
    position: relative;
    margin-top: -100px;

    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: center;
    border-radius: 10px;
    @include media('<=phone-plus') {
    }
    img {
      // width: 50%;
      max-width: 460px;
      // height: auto;
      min-height: 260px;
      object-fit: contain;

      @include media('<=phone-plus') {
        width: 80%;
      }
    }
    label {
      max-width: 100%;
      padding: 2%;
      font-size: 1.3rem;
      @include media('<=phone-plus') {
        padding: 20px;
      }
    }
  }

  .zoom-activity-info-mini {
    position: absolute;
    top: 8px;
    left: 8px;
    max-width: 200px;
    min-width: 20px;
    border-radius: 8px;
    background: #999;
    display: flex;
    flex-direction: column;
    .collapse-bar {
      position: relative;
      width: 100%;
      height: 22px;
      background: #aaa;
      border-radius: 8px;
      text-align: right;
      cursor: pointer;
      i {
        font-size: 0.8rem;
        top: 1px;
        right: 4px;
      }
    }
    label {
      font-size: 1rem;
      color: white;
      padding: 0px 12px 8px 12px;
    }
    label:nth-child(2) {
      font-size: 1.2rem;
      font-weight: bolder;
      margin: 6px 0 0 0;
    }
  }

  .zoom-activation-btns {
    position: relative;
    margin-top: -100px;
    @include media('<=phone-plus') {
      padding-bottom: 40px;
      margin-top: 0px;
    }

    display: flex;
    gap: 14px;
    flex-wrap: wrap;
    align-content: center;
    justify-content: center;
    .join-btn,
    .open-link-btn {
      color: var(--button-text);
      background: var(--button-background);
      padding: 4% 6%;
      border: none;
      font-size: 1.6rem;
      font-weight: bold;
      cursor: pointer;

      display: flex;
      align-items: center;
      border-radius: var(--input-borderRadius);

      &:active {
        transform: scale(0.9);
      }

      @include media('<=phone-plus') {
        padding: 20px;
        font-size: 1.3rem;
      }

      label {
        // font-size: 1.5rem;
        cursor: pointer;
      }
      i {
        margin-top: 10px;
        margin-right: 10px;
        font-size: 1.3rem;
      }
    }
    .open-link-btn {
      background: black;
    }
  }
}

.zoom-window {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 2% 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.iframe-close-btn {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 10;
  width: 36px;
  height: 36px;
  background: var(--button-text);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  i {
    font-size: 2.5rem;
    color: #999;
  }

  &:active {
    transform: scale(0.9);
  }
}

.zoom-app-btn {
  position: relative;
  margin: 10px;
  padding: 8px 12px;
  color: white;
  border: 1px solid white;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
